export type AcceptedColumn =
  | 'mgItem'
  | 'gtin'
  | 'supplierId'
  | 'priority'
  | 'stocked'
  | 'validFrom'
  | 'validTo';

const normalizeHeader = (header: string) => {
  // clean up invisible chars, quotes, and trim
  const cleaned = header
    .replace(/^\uFEFF|[\u200B\u200C\u00A0]/g, '')
    .replace(/["']/g, '')
    .replace(/[\r\n\t]/g, '')
    .trim();

  return cleaned.toLowerCase().split(' ').join('').split('-').join('');
};

export const getIsRecognizedHeaderPredicate = (header: string) => (recHeading: string) =>
  normalizeHeader(header).toLowerCase().includes(recHeading);

export const recognizedMgItemNrHeadings = [
  'mg-item-nummer',
  'mg-item-number',
  'mg-item nummer',
  'mg-item number',
  'mgitemnumber',
  'mgitem-nummer',
  'mgitem-number',
  'mgitem nummer',
  'mgitem number',
  'mgitem-nr',
  'mgitem nr',
  'mgitemnr',
];

export const recognizedGtinHeadings = [
  'gtin',
  'gtinnumber',
  'gtin-number',
  'gtin number',
  'gtin-nummer',
  'gtinnr',
  'gtin-nr',
  'gtin-nr',
];

export const recognizedSupplierIdHeadings = [
  'supplierid',
  'supplier-id',
  'supplier id',
  'mgsupplierid',
  'mgsupplier-id',
  'mg-supplier-id',
  'mgsupplier id',
  'mg supplier id',
];

export const recognizedPriorityHeadings = [
  'priority',
  'itempriority',
  'item-priority',
  'prioritized',
];

export const recognizedStockedStatusHeadings = [
  'stockedstatus(l/b)',
  'lagerstatus(l/b)',
  'stockedstatus(b/l)',
  'lagerstatus(b/l)',
  'stockedstatus',
  'lagerstatus',
];
